import { Component, Inject, OnInit } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigService,
    DateUtilities,
    ModalClass,
    SynchronizationService,
    UserMasterService,
} from '@evorait/pace-core';
import { TranslateService } from '@ngx-translate/core';
import { faChevronDown, faChevronUp, faCodeBranch, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { ChangelogComponent } from '../../../../../../../../libs/pace-core/src/lib/components/changelog/changelog.component';
import { CHANGELOGS } from '../../../../../environments/changelogs';
import { compareSemanticVersions } from '../../../../../../../../libs/pace-core/src/lib/utilities/compare.utils';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'pace-information',
    templateUrl: './pace-information.component.html',
    styleUrls: ['./pace-information.component.scss'],
})
export class PaceInformationComponent implements OnInit {
    public strings: PaceInformationStrings;
    public isPaceOnlineUser: boolean;
    public faChevronDown = faChevronDown;
    public faChevronUp = faChevronUp;
    public isCollapsed = true;
    public faInfoCircle = faInfoCircle;
    public readonly faCodeBranch = faCodeBranch;
    public changelogs = CHANGELOGS.sort((a, b) => -compareSemanticVersions(a.version, b.version)).slice(0, 15);

    public constructor(
        private readonly translate: TranslateService,
        private readonly configService: ConfigService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
        private readonly userMasterService: UserMasterService,
        private readonly synchronizationService: SynchronizationService,
        private readonly modalService: BsModalService,
    ) {
        this.strings = {
            salesOrg: '',
            plant: '',
            plantSalesOrgDescription: '',
            appVersion: this.clientManager.getAppVersion(),
            environment: this.clientManager.getCurrentEnvironment(),
            targetBackend: this.configService.getBackendName(),
        };

        this.isPaceOnlineUser = this.userMasterService.isPaceOnlineUser();
    }

    public ngOnInit(): void {
        this.strings.salesOrg = this.userMasterService.getSelectedUserModel().getSalesOrg();
        this.strings.plant = this.userMasterService.getSelectedUserModel().getPlant();
        this.strings.plantSalesOrgDescription = this.userMasterService.getSelectedUserModel().getDescription();
    }

    public getLastSync(): string {
        return this.synchronizationService.getLastSyncTime().isValid()
            ? DateUtilities.formatDate(this.synchronizationService.getLastSyncTime())
            : <string>this.translate.instant('FREQUENT_ACTIVITIES_FOOTER_NO_SYNC');
    }

    public toggleIsCollapsed(): void {
        this.isCollapsed = !this.isCollapsed;
    }

    public openChangelog(): void {
        this.modalService.show(ChangelogComponent, {
            backdrop: 'static',
            class: ModalClass.MODAL_MEDIUM,
            ariaLabelledBy: 'changelog-modal-title',
            initialState: {
                changelogs: this.changelogs,
            },
        });
    }
}

interface PaceInformationStrings {
    salesOrg: string;
    plant: string;
    plantSalesOrgDescription: string;
    appVersion: string;
    environment: string;
    targetBackend: string;
}
